<template lang="pug">

  .lesson-block.main-block
    .lesson-block__content(v-if="!isEditLocal")
      p.lesson-block__title.main-block__title(v-if="content.header")
        | {{content.header}}

      .lesson-block__row(v-if="Object.keys(content.files).length !== 0")
        File(
          v-for="file in content.files" :key="file.id"
          :file="file"
          :canDelete="false"
        )

</template>

<script>
import _ from 'lodash';
import File from '@/components/File/File';
import UploadFile from '@/components/Form/UploadFiles';

export default {
  components: {
    File,
    UploadFile
  },
  props: {
    isEdit: {
      default: false,
      type: Boolean
    },
    content: {},
    arrows: {
      default: true,
      type: Boolean
    },
    isFirstBlock: {
      default: false,
      type: Boolean
    },
    isLastBlock: {
      default: false,
      type: Boolean
    },
    isLoading: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      contentLocal: {},
      isEditLocal: false,
      uploadingFiles: false,
      optionsFields: [
        {
          text: 'Редактировать',
          func: this.openBlockEdit,
          icon: 'edit'
        },
        {
          text: 'Удалить',
          func: this.deleteBlock,
          icon: 'delete',
          iconWidth: '10px',
          confirm: true,
          confirmTitle: 'Вы уверены, что хотите удалить этот блок?',
          confirmDescription: 'Блок будет удален навсегда',
          confirmApplyText: 'Удалить',
          confirmCancelText: 'Отменить',
          red: true
        }
      ],
      fileExt: ['.odt', '.docx'],
      fileMime: [
        'image/*',
        'application/pdf',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'text/plain',
        'text/csv'
      ]
    };
  },
  watch: {
    isEditDefault() {
      this.isEditLocal = this.isEdit;
    },
    content() {
      this.setData();
    }
  },
  mounted() {
    this.setData();
  },
  methods: {
    setData() {
      this.contentLocal = _.cloneDeep(this.content);
    },
    openBlockEdit() {
      this.isEditLocal = true;
    },
    deleteBlock() {
      this.$emit('deleteBlock');
    },
    saveBlock() {
      setTimeout(() => {
        this.isEditLocal = false;
      }, 1000);

      this.$emit('saveBlock', this.contentLocal);
    },
    cancel() {
      this.isEditLocal = false;
      this.setData();
    },
    moveUp() {
      this.$emit('moveUp');
    },
    moveDown() {
      this.$emit('moveDown');
    },
    async getFiles({ formData }) {
      this.uploadingFiles = true;
      const files = await this.$store.dispatch('ajax/uploadFile', { formData });
      this.uploadingFiles = false;
      if (files) {
        files.forEach(f => {
          this.contentLocal.files.push(f);
        });
      }
    }
  }
};
</script>
